// extracted by mini-css-extract-plugin
module.exports = {"readMoreButton":"ReadMoreBooking_readMoreButton__2p52r","readMoreTextContent":"ReadMoreBooking_readMoreTextContent__U1AUT"};